import { render, staticRenderFns } from "./index.vue?vue&type=template&id=244c7f13&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c7f13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244c7f13')) {
      api.createRecord('244c7f13', component.options)
    } else {
      api.reload('244c7f13', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=244c7f13&scoped=true", function () {
      api.rerender('244c7f13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/role/index.vue"
export default component.exports